const KEY_WELL = 'well';
const KEY_STRATUM = 'stratum';
const KEY_ELEMENT = 'element';

const createInfo = data => {
    const { wells, stratums, elements } = data;

    return {
        W: {
            // data: wells,
            data: [...wells].sort((a, b) => a.index - b.index),
            key: KEY_WELL,
        },
        S: {
            data: stratums,
            key: KEY_STRATUM,
        },
        E: {
            data: elements,
            key: KEY_ELEMENT,
        },
    };
};

const createLevels = (order, meta) => {
    return order.map(item => meta[item]);
};

/*
    Из прямой структуры строится дерево, согласно связям, прописанным в коллекции
    по которой происходит итерация
*/
export const transformDataToTree = (data, order) => {
    if (!data) return {}; // ? Check it

    const { matches } = data;

    const info = createInfo(data);
    const [level0, level1, level2] = createLevels(order, info);

    const tree = {};

    for (const match of matches) {
        const itemIndex0 = match[level0.key];
        const item0 = level0.data[itemIndex0];

        if (!(itemIndex0 in tree)) {
            tree[itemIndex0] = {
                ...item0,
                type: level0.key,
                children: {},
            };
        }

        const itemIndex1 = match[level1.key];
        const item1 = level1.data[itemIndex1];

        if (!(itemIndex1 in tree[itemIndex0].children)) {
            tree[itemIndex0].children[itemIndex1] = {
                ...item1,
                type: level1.key,
                children: {},
            };
        }

        const itemIndex2 = match[level2.key];
        const item2 = level2.data[itemIndex2];

        if (!(itemIndex2 in tree[itemIndex0].children[itemIndex1].children)) {
            tree[itemIndex0]['children'][itemIndex1]['children'][itemIndex2] = {
                ...item2,
                type: level2.key,
            };
        }
    }

    return tree;
};
